export const TASK_STATUSES = ["faol", "yakunlangan", "bekor_qilingan"] as const;
export type TaskStatus = (typeof TASK_STATUSES)[number];

/**
 * Holat tegi ranglari — `TasksPage` va bo'lim profilining "Topshiriqlar"
 * tabi uchun YAGONA manba (`employees/types` dagi `HR_STATUS_COLORS` naqshi).
 */
export const TASK_STATUS_COLORS: Record<TaskStatus, string> = {
	faol: "processing",
	yakunlangan: "success",
	// biome-ignore lint/style/useNamingConvention: backend `tasks.status` enum qiymati aynan shu
	bekor_qilingan: "default",
};

export const TASK_ASSIGNEE_STATUSES = [
	"biriktirilgan",
	"yolda",
	"yetib_borgan",
	"bajarilgan",
	"bajarilmagan",
	"bekor_qilingan",
] as const;
export type TaskAssigneeStatus = (typeof TASK_ASSIGNEE_STATUSES)[number];

/**
 * ⚠️ `yolda` yorlig'i BOR, lekin server uni HECH QACHON YOZMAYDI
 * (spec §6.4) — v1 da «maqsad tomon harakat» evristikasi yo'q. Yorliq
 * saqlanadi, chunki UI serverdan kelgan HAR QANDAY qiymatni
 * ko'rsatishi kerak; uni olib tashlash kelajakdagi evristika
 * yoqilganda jimgina `undefined` chiqarardi.
 *
 * Matnlar `tasks.json`ning `assigneeStatus` kalitida — bu ro'yxat
 * FAQAT qiymatlar to'plami sifatida qoladi (`t(`assigneeStatus.${status}`)`
 * chaqiruvchi joyda).
 */

/** `task_point_radius_m` sozlamasining standarti (kontrakt §5). */
export const TASK_POINT_RADIUS_DEFAULT_M = 30;

export interface TaskGeometry {
	type: "Polygon";
	coordinates: [number, number][][];
}

export interface Task {
	id: string;
	name: string;
	status: TaskStatus;
	departmentId: string | null;
	dueFrom: string;
	dueTo: string;
	targetCount: number;
	assigneeCount: number;
	arrivedCount: number;
	completedCount: number;
	createdAt: string;
	/**
	 * ⚠️ `false` — `department` doira topshiriqni FAQAT ijrochi orqali
	 * ko'rmoqda (egasi doirada EMAS): `update`/`cancel`/`delete` bunday
	 * qatorda 404 qaytaradi (`tasks.repository.ts`ning `findById(scope, id,
	 * "write")`i topa olmaydi). UI amallar shu bayroq bo'yicha yashiriladi
	 * (spec 2026-09-14 §3.2a, yakuniy review I1/A2).
	 */
	canWrite: boolean;
}

export interface TaskTarget {
	id: string;
	orderNo: number;
	kind: "zone" | "point";
	zoneId: string | null;
	center: { lon: number; lat: number } | null;
	radiusM: number | null;
	label: string | null;
	/** ⚠️ Admin konvertida OBYEKT (mobil konvertda SATR). */
	geometry: TaskGeometry;
}

export interface TaskAssignee {
	employeeId: string;
	fullName: string;
	status: TaskAssigneeStatus;
	completedAt: string | null;
	completionNote: string | null;
}

export interface TaskArrival {
	id: string;
	targetId: string;
	employeeId: string;
	arrivedAt: string;
	distanceM: number;
	point: { lon: number; lat: number };
}

export interface TaskDetail extends Task {
	description: string | null;
	/**
	 * ⚠️ Nullable — `tasks.created_by` `ON DELETE SET NULL`
	 * (`tasks.schemas.ts`ning `TaskDetailSchema`si). Yaratuvchi
	 * o'chirilishi mumkin.
	 */
	createdBy: string | null;
	updatedAt: string;
	targets: TaskTarget[];
	assignees: TaskAssignee[];
	arrivals: TaskArrival[];
}

export type TaskTargetInput =
	| { kind: "zone"; zoneId: string; label?: string | null }
	| {
			kind: "point";
			center: { lon: number; lat: number };
			radiusM?: number | null;
			label?: string | null;
	  };

export interface TaskCreateInput {
	name: string;
	description?: string | null;
	/** ⚠️ Faqat UTC `Z` — server `+05:00` ni RAD ETADI. */
	dueFrom: string;
	dueTo: string;
	targets: TaskTargetInput[];
	assigneeIds: string[];
}

export type TaskUpdateInput = Partial<Omit<TaskCreateInput, "targets">>;

export interface TaskListFilters {
	status?: TaskStatus;
	employeeId?: string;
	q?: string;
	/** Topshiriq YARATILGAN bo'lim (`tasks.department_id`) — bo'lim profili tabi. */
	departmentId?: string;
	/** Ijrochilaridan biri shu bo'limda — bo'lim profilining "kelgan" ro'yxati. */
	assigneeDepartmentId?: string;
	/** `departmentId`/`assigneeDepartmentId` ning avlodlarini ham qamraydi. */
	includeDescendants?: boolean;
}
